/* eslint-disable */
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Bttn } from 'dbrain-web-ui-lib'
import config from '../../config'
import Logo from './img/alpha_logo.svg'

import './style'

class Header extends Component {
	render() {
		return (
			<div className="header">
				<Link
					className="logo"
					to={config.routes.index}
				>
					<img src={Logo} alt="" />
				</Link>
				{/* <a className="logo" href={config.outer.index}>
					<img src={Logo} alt="" />
				</a> */}

				<div className="header-buttons">
					<Bttn
						size="small"
						type="bordered-gray"
						target="_blank"
						className="header-buttons-item sm-hidden"
						rel="noopener noreferrer"
						href={config.outer.signup}
					>
						Sign up to work
					</Bttn>
					<Bttn
						size="small"
						type="black-on-gray"
						target="_blank"
						className="header-buttons-item sm-hidden"
						rel="noopener noreferrer"
						href={config.outer.form}
					>
						Request free trial
					</Bttn>
				</div>
			</div>
		)
	}
}

export default Header
